import { render, staticRenderFns } from "./RolePanel.vue?vue&type=template&id=a51e550c&"
import script from "./RolePanel.vue?vue&type=script&lang=js&"
export * from "./RolePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports